<!-- TopLevelSelector -->
<template>
  <div class="top-level-selectors diff_select">
    <div class="row" v-if="$props.info !=null">
      <div :class="colMd" v-for="(row, i) in $props.info" :key="i">
        <router-link class="btn btn-xl btn-selector" :class="row.btnclass" :to="{path: row.path}"> {{ row.title }} </router-link>
        <p class="presents" v-if="row.presents != null"> {{ row.presents }} </p>
        <p class="description" v-if="row.description != null"> {{ row.description }} </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: [
      'info',
      'btnclass'
    ],
    computed: {
      colMd: function() {
        return 'col-md-' + (12 / this.$props.info.length);
      }
    }
}
</script>

<style>
p.presents{
    text-decoration-line: underline;
    text-decoration-color: #232323; 
}
p.description{
    font-weight: 300;
    padding: 5px 10px;
}

/* ボタンの共通設定 */
.btn-selector {
    animation: fadeIn 0.5s ease-in 0s 1 normal;
    -webkit-animation: fadeIn 1s ease 0s 1 normal;
    border: solid 0.05em rgba(150,150,150,0.3);
    font-weight: 500!important;
    font-size: 2.5rem;
    margin: 20px 0;
    text-align: center;
    padding: 15px;
}


.diff_select{
    animation: fadeIn 0.5s ease-in 0s 1 normal;
    -webkit-animation: fadeIn 1s ease 0s 1 normal;
    border: solid 0.05em rgba(150,150,150,0.3);
    background-color: rgba(255,255,255,0.7);
    margin: 20px 0;
    text-align: center;
    padding: 15px;
}

/*
.diff_btn{
    width: 80%;
    margin-bottom: 5px;
    color: #FEFEFE;
    font-weight: 500!important;
    background-color: gray;
}
*/


</style>